import React, { useState, useCallback } from 'react'
import { Container, Row, Col, Button } from 'reactstrap'

import { InactivityOverlay, CheckoutAssistantComponents } from '@components'
import { useCartRedux, useCashRegister, usePaymentEvents } from '@hooks'

const CheckoutAssistantPage = () => {
    const [isOpen, setIsOpen] = useState(false)

    const open = useCallback(() => setIsOpen(true), [])
    const close = useCallback(() => setIsOpen(false), [])

    const { assistantInfo, assistantCarts } = useCartRedux()
    const { joinedGroupName, isAutoJoining } = useCashRegister()
    const { paymentEvent, handlePaymentEventClose, handlePaymentRequest } = usePaymentEvents()

    const currentCart = joinedGroupName ? assistantCarts[joinedGroupName] : null

    return (
        <div className="min-vh-100 p-1 p-sm-2 p-md-3 position-relative" style={{ fontSize: '1.1rem' }}>
            <Container fluid>
                <Row className="align-items-center mb-4">
                    <Col className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center justify-content-center">
                            <div className="display-6 m-0 fw-bold" style={{ fontSize: '2.5rem' }}>
                                Order Summary
                            </div>
                            <div className="display-6 m-0 fw-bold text-primary ms-2">
                                {assistantInfo?.orderNumber ? `#${assistantInfo?.orderNumber}` : ''}
                            </div>
                        </div>

                        <CheckoutAssistantComponents.GroupConnectionStatus
                            isAutoJoining={isAutoJoining}
                            joinedGroupName={joinedGroupName}
                        />
                    </Col>
                    <Col xs="auto">
                        <Button
                            color="light"
                            className="rounded-circle border border-3 border-dark d-inline-flex align-items-center justify-content-center p-0"
                            style={{
                                width: 56,
                                height: 56,
                                minWidth: 56,
                                minHeight: 56,
                                touchAction: 'manipulation',
                            }}
                            aria-label="Settings"
                            onClick={open}
                        >
                            <i className="bx bx-cog icon-close " style={{ fontSize: '1.5rem' }} />
                        </Button>
                    </Col>
                </Row>

                <main>
                    {/* Cart display */}
                    <div className="rounded-4 bg-white" style={{ minHeight: '70vh', display: 'flex', flexDirection: 'column' }}>
                        <CheckoutAssistantComponents.CartDisplay
                            currentCart={currentCart}
                            assistantInfo={assistantInfo}
                            isAutoJoining={isAutoJoining}
                        />
                    </div>
                </main>
            </Container>

            <CheckoutAssistantComponents.SettingsModal isOpen={isOpen} toggle={close} />

            <InactivityOverlay
                idleSeconds={60}
                message={joinedGroupName === 'pos-CASH_REGISTER-6' ? 'Welcome to Tian Tian' : 'Welcome to ABZ Cafe'}
                isActive={!paymentEvent.isVisible && (!currentCart || !currentCart.items || currentCart.items.length === 0)}
            />

            <CheckoutAssistantComponents.PaymentEventModal
                isVisible={paymentEvent.isVisible}
                eventType={paymentEvent.eventType}
                eventData={paymentEvent.eventData}
                onClose={handlePaymentEventClose}
                onPaymentRequest={handlePaymentRequest}
            />
        </div>
    )
}

export default CheckoutAssistantPage
